<template>
  <div class="model-box portfolio-b">
    <div class="title">
      <div class="ui-title">{{ modelData.title }}</div>
    </div>

    <div class="sp clearfix">
      <div class="l">
        <div class="img-list clearfix">
          <div class="ui-img-box">
            <div class="ui-img">
              <div class="s-img" :style="'background-image: url(' + modelData.img1 + ');'"></div>
            </div>
          </div>

          <div class="ui-img-box">
            <div class="ui-img">
              <div class="s-img" :style="'background-image: url(' + modelData.img2 + ');'"></div>
            </div>
          </div>

          <div class="ui-img-box">
            <div class="ui-img">
              <div class="s-img" :style="'background-image: url(' + modelData.img3 + ');'"></div>
            </div>
          </div>

          <div class="ui-img-box">
            <div class="ui-img">
              <div class="s-img" :style="'background-image: url(' + modelData.img4 + ');'"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="r">
        <div class="edit">
          <div
            v-html="htmlDecode(modelData.edit || '')"
            class="ui-edit"
            style="height: 337px; color: #707070; font-size: 13px"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { htmlDecode, formatImgData } from './../../utils/utils.js'

export default {
  props: {
    data: {
      default: () => ({}),
      type: Object
    },
    index: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      modelData: {}
    }
  },
  mounted() {},
  watch: {
    data: function () {
      this.modelData = this.formatImgData(this.data, 4)
    },
    modelData: function () {
      this.$emit('postdata', this.modelData, this.index)
    }
  },
  created() {
    this.modelData = this.formatImgData(this.data, 4)
  },
  methods: {
    htmlDecode,
    formatImgData
  }
}
</script>
<style lang="less">
@import '~@/assets/css/journalModel.less';
</style>
